var getMarker = function (className, content) {
    return '<div class="' + className + '">' + content + '</div>'
}

export { getMarker }